import { useThemeSlice } from "../ui/StatusBadge.jsx";

export function SidebarLogo({ isCollapsed }) {
  const { c, accentHex: A } = useThemeSlice();
  return (
    <div
      style={{
        flexShrink: 0,
        borderBottom: `1px solid ${c.sbBdr}`,
        background: c.sb,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: isCollapsed ? "14px 0" : "16px 16px",
        transition: "padding .25s",
        minHeight: isCollapsed ? 60 : 102,
      }}
    >
      <svg
        viewBox={isCollapsed ? "0 0 80 185.1" : "0 0 426.3 185.1"}
        style={{
          height: isCollapsed ? 38 : 70,
          width: "auto",
          maxWidth: isCollapsed ? 38 : "100%",
          display: "block",
          transition: "height .25s, max-width .25s",
          overflow: "visible",
        }}
      >
        {!isCollapsed && (
          <path
            fill={c.text}
            d="M13.4,169.6h4.3l4.8-27.3h-4.3C18.2,142.3,13.4,169.6,13.4,169.6z M60.4,162.3l-12-20.1H45l-4.8,27.3h4.4l3.4-20l12,20h3.4l4.8-27.3h-4.4L60.4,162.3z M96.2,146.2L92,169.6h4.4l4.1-23.4h8.9l0.7-3.9H87.9l-0.7,3.9H96.2z M145.3,169.6l0.7-4.3h-15.8l1.3-7.3h14.1l0.7-4.1h-14.1l1.3-7.5h14.9l0.7-4.1h-19.2c-0.8,4.6-1.6,9.1-2.4,13.7c-0.8,4.5-1.6,9.1-2.4,13.7L145.3,169.6L145.3,169.6z M175.2,142.3h-4.4l-4.8,27.3h18.8l0.7-4.1h-14.4L175.2,142.3z M213.6,142.3h-4.4l-4.8,27.3h18.8l0.7-4.1h-14.4L213.6,142.3z M242.9,169.6h4.3l4.8-27.3h-4.3L242.9,169.6z M293.3,166.2l-2.5-3.1c-1.1,1-2.4,1.7-3.8,2.2c-1.4,0.5-2.7,0.8-4,0.8c-1.8,0-3.2-0.3-4.4-0.9c-1.2-0.6-2.1-1.3-2.7-2.2c-0.7-0.9-1.1-2-1.2-3.2c-0.2-1.2-0.1-2.4,0.1-3.7c0.2-1.2,0.6-2.5,1.2-3.7c0.6-1.2,1.4-2.3,2.4-3.3c1-0.9,2.2-1.7,3.6-2.3c1.4-0.6,2.9-0.9,4.7-0.9c1.3,0,2.5,0.2,3.6,0.7c1.1,0.5,2.1,1.2,3,2.1l3.2-2.9c-1.1-1.4-2.5-2.4-4-3.1c-1.5-0.6-3.2-1-5-1c-2.8,0-5.2,0.5-7.3,1.5c-2.1,1-3.9,2.3-5.4,3.8c-1.5,1.6-2.6,3.4-3.3,5.3c-0.8,2-1.1,4-1.1,6c0,1.5,0.2,3,0.7,4.4c0.5,1.4,1.2,2.7,2.2,3.7c1,1.1,2.2,1.9,3.8,2.6c1.5,0.6,3.4,1,5.5,1c1,0,2-0.1,2.9-0.2c0.9-0.1,1.9-0.4,2.8-0.7c0.9-0.3,1.8-0.7,2.7-1.2C291.6,167.5,292.4,166.9,293.3,166.2L293.3,166.2z M332.9,163.9l1.6,5.7h4.5l-7.5-27.3h-4.8l-17.1,27.3h4.8l3.6-5.7H332.9z M328.6,146.9l3.5,13h-11.6L328.6,146.9z M381.9,169.6l-0.3-0.8l-6.6-9.1c1.6-0.2,3-0.7,4.1-1.3c1.1-0.7,2.1-1.5,2.8-2.4c0.7-0.9,1.3-1.9,1.6-3c0.3-1.1,0.5-2.1,0.5-3.2c0-1-0.2-2-0.5-2.9c-0.3-0.9-0.8-1.7-1.5-2.4c-0.7-0.7-1.5-1.3-2.6-1.7c-1-0.4-2.2-0.6-3.6-0.6c-2.1,0-4.2,0-6.3,0c-2.1,0-4.2,0-6.3,0l-4.8,27.4h4.4l1.7-9.4h5.8l6.6,9.4L381.9,169.6L381.9,169.6z M366.8,146.3h8.4c0.8,0,1.5,0.1,2,0.4c0.6,0.2,1,0.6,1.4,1c0.4,0.4,0.6,0.8,0.8,1.3c0.2,0.5,0.3,1,0.3,1.5c0,0.7-0.1,1.4-0.4,2.1s-0.6,1.3-1.2,1.8c-0.5,0.5-1.1,1-1.9,1.3c-0.8,0.3-1.7,0.5-2.7,0.5h-8.3L366.8,146.3L366.8,146.3z"
          />
        )}
        <path
          fill={A}
          d="M52.9,119.9c7.9-4,15.1-8.4,22.6-12.4c31.6-16.7,60.1-34.4,95.4-45.8c22.8-7.4,37-6.7,59,1.2c16.7,6,32.7,15.1,47.4,23.1c21.9,11.9,38.9,22.4,64.1,27.7c24.9,5.3,58.6,9.8,66.3,23.2c5.7,10-15.2,18.6-12.4,22.5c47.2-28.5,2.4-40.3-28.4-47.6c-15.1-3.6-24-5.4-32.6-8.3c-24.4-8.3-54.8-29.5-79.8-41.7c-44.8-21.9-65.8-20.5-111.6-1c-8.6,3.7-66,33.6-92.7,47.9c-5.6,3-31.1,17.5-25.4-0.4l18.7-58.6l-32.3,1.9l-1.7,6.1c6.8,0,10.9,0.4,12.4,1.1c4.2,2.1,1.3,9.6,0.2,12.9c-4.3,13.2-9.9,28.1-13,41.5c-3.1,13.1,2.6,21.4,15.8,18.6C35.3,129.5,43.7,124.6,52.9,119.9L52.9,119.9z"
        />
        <path fill={A} d="M44.4,20.8c2,2,3.1,4.5,3.1,7.4c0,2.9-1,5.4-3.1,7.4c-2.1,2.1-4.5,3.1-7.4,3.1c-2.9,0-5.3-1-7.4-3.1c-2-2.1-3.1-4.6-3.1-7.4c0-2.9,1-5.4,3-7.4c2-2,4.5-3,7.4-3C39.8,17.8,42.3,18.8,44.4,20.8L44.4,20.8z" />
      </svg>
    </div>
  );
}
